import { AppsOutlined } from "@mui/icons-material";
import { Box, Drawer, IconButton, Paper } from "@mui/material";
import Slider from "react-slick";
import { MPhotographSection } from "./MPhotographSection";
import { useState } from "react";

const settings = {
  dots: true,
  infinite: true,
  centerPadding: "60px",
  slidesToShow: 1,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
};
export function MBannerSection() {
  const [openPhoto, setOpenPhoto] = useState(false);

  const handleClosePhotograph = () => {
    setOpenPhoto(false);
  };
  return (
    <Box
      position="relative"
      width="100vw"
      sx={{
        ".slick-dots": {
          bottom: "5px",
          //   width: "min-content"
        },
        ".slick-dots li": {
          margin: 0,
        },
        ".slick-dots li button::before": {
          color: "white",
        },
      }}
    >
      <Slider className="carousel-slider" {...settings}>
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Slider>
      <IconButton
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.6)",
          position: "absolute",
          bottom: 5,
          right: 5,
        }}
        onClick={() => setOpenPhoto(true)}
      >
        <AppsOutlined fontSize="small" style={{ color: "white" }} />
      </IconButton>

      <Drawer
        open={openPhoto}
        onClose={handleClosePhotograph}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <MPhotographSection handleClose={handleClosePhotograph} />
      </Drawer>
    </Box>
  );
}

function Project({ item }: { item: number }) {
  return (
    <Paper
      elevation={0}
      sx={{
        overflow: "hidden",
      }}
    >
      <img
        className="bannerImg"
        width="100%"
        style={{ maxHeight: "100%" }}
        src={`/images/store-detail/img${item}.jpg`}
        alt="Imgage"
      />
    </Paper>
  );
}

const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
